import { white, gray } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, boxShadows, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const uploadPreviewContainer = style({
  position: 'relative',
  minHeight: 0,
  minWidth: 0,
  backgroundColor: gray[300],
  borderRadius: borderRadius.r12,
});
export const uploadPreviewContainerCompact = style({
  width: 64,
  height: 64,
});
export const uploadPreview = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 'inherit',

  selectors: {
    'video.&': {
      objectFit: 'contain',
    },
  },
});

export const uploadPreviewLoader = style({
  ...typography['bodyMd'],
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  color: white[900],
  borderRadius: 'inherit',
});

export const uploadPreviewError = style({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  borderRadius: 'inherit',
});

export const uploadPreviewRemoveContainer = style({
  position: 'absolute',
  right: space.s8,
  top: space.s8,
  backgroundColor: themeVars.container.primary.background.idle,
  padding: space.s2,
  borderRadius: '100%',
});

export const uploadPreviewRemoveContainerCompact = style({
  right: -space.s8,
  top: -space.s8,
  boxShadow: boxShadows.default,
  selectors: {
    [`${uploadPreviewContainer}:hover &`]: {
      visibility: 'visible',
    },
  },

  '@media': {
    ['(pointer:fine)']: {
      selectors: {
        '&:has(> [data-state="closed"])': {
          visibility: 'hidden',
        },
      },
    },
  },
});

export const uploadPreviewRemoveCompact = style({
  selectors: {
    '&:is(&)': {
      width: 20,
      height: 20,
    },
  },
});
